<template>
  <v-container>
    <div class="pt-4 pb-4">
      <span class="title">Accounting</span>
    </div>

    <v-card class="pa-4">
      <div class="title mb-4 font-weight-medium">
        Monthly Readouts
      </div>
      <div>
        <div>
          Disposed / Expired for Month
        </div>
        <div>
          Spillage / Expired / Damaged etc need to all be on a separate list
        </div>
        <div class="blue--text mb-4">
          - Inventory Transactions (Pricelist: RM)
        </div>
        <div>
          Finished products on stock
        </div>
        <div class="blue--text mb-4">
          - DB Historical, Finished product (Pricelist: Whole_sale_2023)
        </div>
        <div>
          Raw materials on stock
        </div>
        <div class="blue--text mb-4">
          - DB Historical, Raw material (Pricelist: RM)
        </div>
        <div>
          Production inputs for month
        </div>
        <div class="blue--text mb-4">
          - Production inputs (Pricelist: RM)
        </div>

        <div>
          Production outputs for month
        </div>
        <div class="blue--text mb-4">
          - Products Produced (Pricelist: CP)
        </div>
        <div class="pink--text mt-6">
          Only use ONE pricelist at a time / duplicate items if more than one pricelist is loaded in
        </div>
      </div>
    </v-card>

    <v-card class="mt-4">
      <v-row class="pa-2">
        DB HISTORICAL
      </v-row>
      <db-historical></db-historical>
    </v-card>

    <!--
    <v-card class="mt-4">
      <v-row class="pa-2">
        Stock On Hand at Historial Point In Time
      </v-row>
      <stock-at-historical-point-in-time></stock-at-historical-point-in-time>
    </v-card>
    -->

    <v-card class="mt-4">
      <div class="pa-2 d-flex align-center title">
        <img class="" src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="60px">
        SALES
      </div>
      <sales-card></sales-card>
    </v-card>

    <v-card class="mt-4">
      <div class="pa-2 d-flex align-center title">
        <img class="" src="@/assets/img/illustrations/ingredients.png" alt="cardboard box" width="60px">
        Production Inputs for period
      </div>
      <production-inputs></production-inputs>
    </v-card>

    <v-card class="mt-4">
      <div class="pa-2 d-flex align-center title">
        <img class="" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="60px">
        Products Produced
      </div>
      <products-produced></products-produced>
    </v-card>

    <v-card class="mt-4">
      <v-row class="pa-2">
        Finished products in stock (LIVE) || Dateis not taken into account here, This will be removed in future unless a use is found for it
      </v-row>
      <finished-products-in-stock></finished-products-in-stock>
    </v-card>

  </v-container>
</template>

<script>
import ProductsProduced from './produced-products-for-period/Main'
import ProductionInputs from './production-inputs-for-period/Main'
import FinishedProductsInStock from './finished-products-on-hand/Main'
import SalesCard from './sales/Main'
// import StockAtHistoricalPointInTime from './stock-on-hand-at-time/Main'
import DbHistorical from './stock-on-hand-at-time/Main'

export default {
  components: {
    ProductsProduced,
    ProductionInputs,
    FinishedProductsInStock,
    SalesCard,
    // StockAtHistoricalPointInTime,
    DbHistorical
  },
  data () {
    return {

    }
  }
}
</script>